module.exports = __webpack_public_path__ + "static/img/mobilegreen4.374f435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilegreen4.png
// module id = oUal
// module chunks = 1